import { useEffect, useState } from 'react'
import { Color, LuxIcon } from '@lux/wardrobe-lib'
import { Accordion as PrimeAccordion, AccordionTab } from 'primereact/accordion'
import './Accordion.scss'

const Accordion = (props: {
    title: string
    onClose?: () => void
    id?: number
    children?: any
    extraIcon?: string
    extraIconColor?: Color
    activeIndex?: number
    disabled?: boolean
    setActiveIndex?: (activeIndex: 0 | null) => void
    customIcon?: any
    className?: string
    progress?: number
    taskCreationDate?: any
}) => {
    const {
        title,
        id,
        children,
        disabled,
        extraIcon,
        extraIconColor,
        onClose,
        activeIndex,
        setActiveIndex,
        customIcon,
        className,
        progress,
        taskCreationDate
    } = props

    const [showContent, setShowContent] = useState(false)
    const [dateCheck, setDateCheck] = useState(true)
    const [status, setStatus] = useState('')

    const componentClass = 'smart-modals-accordion'

    const getHeaderTemplate = () => {
        return (
            <div className={`${componentClass}__header`}>
                <div className={`${componentClass}__header-title`}>{title}</div>
                <div className={`${componentClass}__header-icons-container`}>
                    {props.customIcon}
                    {extraIcon && <LuxIcon icon={extraIcon} color={extraIconColor} />}
                    <LuxIcon icon={`caret-${showContent ? 'up' : 'down'}`} />
                </div>
            </div>
        )
    }

    const onTabOpen = () => {
        setShowContent(true)
        setActiveIndex && setActiveIndex(0)
    }
    const onTabClose = () => {
        setShowContent(false)
        onClose && onClose()
        setActiveIndex && setActiveIndex(null)
    }

    useEffect(() => {
        if (activeIndex === 0) {
            setShowContent(true)
        }
    }, [activeIndex])

    useEffect(() => {
        if(!dateCheck) {
            if(progress < 100) {
                setStatus('not_completed')
            } else {
                setStatus('completed')
            }
        }
    }, [dateCheck])

    useEffect(() => {
        if(taskCreationDate?.length > 0) {
            taskCreationDate?.map((item) => {
                if (new Date().getTime() >= new Date(item.startDate).getTime()) {
                    if(progress < 100) {
                        setStatus('not_completed')
                    } else {
                        setStatus('completed')
                    }
                } else {
                    setDateCheck(false)
                }
            })
        } else {
            if(progress < 100) {
                setStatus('not_completed')
            } else {
                setStatus('completed')
            }
        }
    }, [taskCreationDate, progress])

    return (
        <div
            className={`${componentClass} ${showContent ? 'bg-grey' : ''} ${
                className ? className : ''
            }`}>
            {progress > 0 && <div className={`${componentClass}__bar`}>
                <div
                    data-progress={progress}
                    style={{ width: `${!status ? 0 : progress}%` }}
                    className={`${componentClass}__bar__progress`}
                />
            </div>}
            <PrimeAccordion
                onTabOpen={onTabOpen}
                onTabClose={onTabClose}
                activeIndex={activeIndex === 0 ? activeIndex : null}>
                <AccordionTab header="" headerTemplate={getHeaderTemplate()} disabled={disabled}>
                    <div className={`${componentClass}__content-wrapper`}>
                        <div className={`${componentClass}__content`}>{children}</div>
                    </div>
                </AccordionTab>
            </PrimeAccordion>
        </div>
    )
}

export default Accordion
